import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Switch, Alert, Spin } from 'antd';
import { adminAPI } from '../api/admin';

const { TextArea } = Input;
const CONFIG_KEY = 'journey_intro_video';

export default function JourneyVideoManager() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getAppConfig(CONFIG_KEY);
      if (response.data.success) {
        form.setFieldsValue(response.data.config.value || {});
      }
    } catch (error) {
      // اگر هنوز seed نشده، مقادیر پیش‌فرض خالی می‌مانند
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    setSaving(true);
    try {
      const response = await adminAPI.upsertAppConfig(CONFIG_KEY, values);
      if (response.data.success) {
        message.success('تنظیمات ویدیو ذخیره شد!');
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'خطا در ذخیره تنظیمات');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card title="ویدیوی توضیحی ابتدای سفر">
      <Alert
        type="info"
        message="یک ویدیوی کلی که در شروع سفر کاربر (JourneyPage) نمایش داده می‌شود تا بهتر متوجه شود مراحل بعدی چیست. لینک آپارات یا یوتیوب را وارد کنید (لینک embed، نه لینک صفحه‌ی معمولی)."
        style={{ marginBottom: 16 }}
      />
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item name="enabled" label="نمایش ویدیو فعال باشد؟" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item
            name="url"
            label="لینک embed ویدیو (آپارات یا یوتیوب)"
            extra="مثال آپارات: https://www.aparat.com/video/video/embed/videohash/XXXXX/vt/frame — مثال یوتیوب: https://www.youtube.com/embed/XXXXXXXXXXX"
          >
            <Input placeholder="https://www.aparat.com/video/video/embed/..." dir="ltr" />
          </Form.Item>

          <Form.Item name="title" label="عنوان بالای ویدیو">
            <Input placeholder="قبل از شروع، این ویدیو رو ببین" />
          </Form.Item>

          <Form.Item name="description" label="توضیح کوتاه زیر عنوان">
            <TextArea rows={3} placeholder="در این ویدیوی کوتاه توضیح می‌دیم مراحل بعدی چیه..." />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>
              ذخیره
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
}
